<script>
import { Line } from 'vue-chartjs'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'

export default {
  components: {
    hexToRgba,
    CustomTooltips
  },
  props: {
    stepSize: {
      type: Number,
      default: 5000000
    },
    max: {
      type: Number,
      default: 30000000
    },
    yAxisCurrency: {
      type: Boolean,
      default: true
    },
    yAxisPercentaje: {
      type: Boolean,
      default: false
    },
  },
  extends: Line,
  mounted () {
    this.renderChart(
      {
        labels: [],
        datasets: [
          {
            label: 'Sin datos',
            backgroundColor: hexToRgba('#E46651', 90),
            data: []
          },
        ]
      },
      {
        responsive: true,
        // height: 300,
        // maintainAspectRatio: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: false,
          custom: CustomTooltips,
          intersect: true,
          mode: 'index',
          position: 'nearest',
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }
            }
          }
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 2,
              stepSize: 1,
              min: 0,
              max: 10
            },
            gridLines: {
              display: true
            }
          }]
        },
      }
    )
  },
  methods: {
    render(labels, data, stepSize, max) {
      let self = this;

      stepSize = stepSize || self.stepSize;
      max = max || self.max;

      this.renderChart(
        {
          labels: labels,
          datasets: data
        },
        {
          responsive: true,
          // responsive: false,
          // height: 300,
          // maintainAspectRatio: true,
          maintainAspectRatio: false,
          tooltips: {
            enabled: false,
            custom: CustomTooltips,
            intersect: true,
            mode: 'index',
            position: 'nearest',
            callbacks: {
              labelColor: function (tooltipItem, chart) {
                return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }
              }
            }
          },
          legend: {
            display: true
          },
          elements: {
            point: {
              radius: 0,
              hitRadius: 10,
              hoverRadius: 4,
              hoverBorderWidth: 3
            }
          },
          scales: {
            xAxes: [{
              gridLines: {
                drawOnChartArea: false
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                // maxTicksLimit: 2,
                min: 0,
                max: max,
                stepSize: stepSize,
                // Include a dollar sign in the ticks
                callback: function(value, index, ticks) {
                  if (self.yAxisCurrency) {
                    return new Intl.NumberFormat("es-AR", {style: "currency", currency: "ARS"}).format(parseFloat(value));
                  }
                  if (self.yAxisPercentaje) {
                    return new Intl.NumberFormat("es-AR", {style: "percent", minimumFractionDigits: 2}).format(parseFloat(value) / 100.00);
                  }
                  return value;
                  // return this.$options.filters.moneda(value);
                }                
              },
              gridLines: {
                display: true
              }
            }]
          },
        }
      )
    }
  }
}
</script>
